export const userReducer = (state, action) => {
  switch (action.type) {
    case 'LOGIN':
      return {authenticated: true, ...action.payload};
    case 'LOGOUT':
      return {};
    default:
      return state;
  }
};

export const roleReducer = (state, action) => {
  switch (action.type) {
    case 'ROLE':
      return {...action.payload};
    default:
      return state;
  }
};

const initialUser = {
  id: 0,
  authenticated: false,
  ...(JSON.parse(localStorage.getItem('user')) || JSON.parse(sessionStorage.getItem('user')) || {})
};

export const initialRole = {
  ...(JSON.parse(localStorage.getItem('role')) || JSON.parse(sessionStorage.getItem('role')) || {})
};

initialUser.authenticated = !!initialUser?.access_token || !!initialUser?.access;
export {initialUser};
